"use client";
import { useT } from "providers/I18nProvider";

/** Chèn chuỗi i18n vào server component (vd h1 trang chủ theo VI/EN). */
export default function T({ k }: { k: string }) {
  const t = useT();
  return <>{t(k)}</>;
}
